import type { CoinMode } from '@ui/hooks/useCoinMode';

export const unstakePeriodDict: Record<
  CoinMode,
  {
    batchDays: number;
    unbondingDays: number;
  }
> = {
  cro: {
    batchDays: 4,
    unbondingDays: 28,
  },
  atom: {
    batchDays: 3,
    unbondingDays: 21,
  },
};
